/* @flow */

import { transparentize } from 'polished';

import { white } from '@e180/ui/lib/token/palette';

export default {
  root: {
    margin: '1.5rem 0 24px',
    padding: 0,
  },
  label: {
    marginBottom: '2em',

    color: transparentize(0.65, white),

    fontSize: 13,
    fontWeight: 500,
    letterSpacing: 2,
    textAlign: 'center',
    textTransform: 'uppercase',
  },
};
